import { z } from "zod";

const SubscriberActivitiesSchema = z
  .object({
    userId: z.string().uuid(),
    search: z.string(),
    continuationToken: z.string().nullable(),
    query: z.any().optional(),
  })
  .strict();

export default SubscriberActivitiesSchema;
